<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->

<script>
import Vue from "vue";
import InputDatePicker from "./InputDatePicker.vue";

import { isBlank } from "../utils/validationUtils";

export default Vue.extend({
  name: "InputPreviousVaccineDatePicker",
  mixins: [InputDatePicker],
  data() {
    return {
      isValid: true,
    }
  },
  props: {
    mlLibJson:Object,
    isAdminMode: {
      type: Boolean,
      default: false,
    },
    isLiffMode: {
      type: Boolean,
      default: false,
    },
    isValidatePreviousVaccineDate: Boolean
  },
  methods: {
    validateRequired() {
      const requiredMessage = "必須です";
      if (this.params.isRequired?.value) {
        return !isBlank(this.dateFormatted) || requiredMessage;
      }
      if (this.isAdminMode) {
        return this.isValid || requiredMessage;
      }
      if (this.isLiffMode) {
        // LIFFは必ずチェック
        return !isBlank(this.dateFormatted) || requiredMessage;
      }
      return true;
    },
  },
  watch: {
    isValidatePreviousVaccineDate(value) {
      this.isValid = value;
    },
    dateFormatted(value) {
      this.isValid = this.isValidatePreviousVaccineDate || !isBlank(this.dateFormatted);
    },
  },
});
</script>
